<template>
  <div class="video-player">
    <div class="w1240 video-player-flex">
      <div class="video-box">
        <Player :playAuth="playAuth" :vid="vid" :chapterId="chapterId" question="false"/>
        <Msgbox />
      </div>
      <div class="video-content-wrap">
        <VideoContent :teacherId="teacherId" v-if="0"/>
      </div>
    </div>
  </div>
</template>

<script>
import Player from "./components/Player.vue";
import VideoContent from "./components/VideoContent.vue";
import Msgbox from "./components/Msgbox.vue";
import { getPlayAuth } from "@/api/CourseCenter";
export default {
  name: "VideoPlayer",
  components: {
    Player,
    VideoContent,
    Msgbox,
  },
  data() {
    return {
      playAuth: "",
      vid:"",
      id: "",
      chapterId: "",
      teacherId: "",
    };
  },
  mounted() {
    this.$store.state.isVideo = true;
    this.id = this.$route.query.id;
    this.teacherId = this.$route.query.teacherId;
    this.chapterId = this.$route.query.chapterId;
    this.getPlayAuthFunc();

      // 禁用右键菜单
      document.addEventListener("contextmenu", (e) => {
        e.preventDefault();
      });

      // 禁用开发者工具
      document.addEventListener("keydown", (e) => {
        if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I")) {
          e.preventDefault();
        }
      });
    },
  methods: {
    getPlayAuthFunc() {
      getPlayAuth(this.id)
        .then((res) => {
          console.log("getPlayAuth")
          console.log(res)
          if(res.status===401){

            localStorage.clear();
          }
          this.playAuth = res.data.playAuth;
          this.vid=res.data.videoMeta.videoId;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  destroyed() {
    this.$store.state.isVideo = false;
  },
};
</script>

<style lang="scss">
.video-player {
  background-color: #333;
  padding-top: 64px;
  .video-player-flex {
    display: flex;
    justify-content: space-between;
  }
  .video-box {
    flex: 1;
    margin-right: 56px;
  }
  .video-content-wrap {
    width: 419px;
    min-width: 419px;
  }
}
@media screen and (min-width: 1580px) {
  .video-player-flex {
    width: 1580px !important;
  }
}
</style>
